import { useEffect, useState } from "react";
import Annalogo from "../images/newanna-removebg-preview.png";
import { ArrowUpRight } from "lucide-react";
import { ArrowRight } from "lucide-react";


export default function Navbar() {
  const [loaded, setLoaded] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => setLoaded(true), 150);
  }, []);

  const navItems = [
    { label: "About", id: "about" },
    { label: "Our Mission", id: "mission" },
    { label: "Our Approach", id: "core-pillar" },
    { label: "Projects", id: "projects" },
    { label: "Programs", id: "programs" },
    { label: "Partnerships", id: "partnerships" },
  ];

  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
    setOpen(false);
  };

  return (
    <div className="w-full flex justify-center px-4 absolute top-0 left-0 z-50 mt-8 lg:mt-12">
      
      {/* NAVBAR */}
      <div
        className={`flex items-center justify-between w-full max-w-7xl 
        bg-[#f5f1ea]/80 backdrop-blur-md border border-green-100
        text-[#000000]
        px-6 sm:px-10 py-4 
        rounded-full shadow-sm
        transition-all duration-700 ease-out
        ${
          loaded
            ? "opacity-100 translate-y-0"
            : "opacity-0 -translate-y-6"
        }`}
      >
        {/* Logo */}
        <div className="flex items-center gap-2 cursor-pointer">
          <img
            src={Annalogo}
            alt="ANNA Logo"
            className="w-24 h-12 lg:w-32 lg:h-12 object-contain"
          />
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10 text-sm lg:text-lg font-medium">
          {navItems.map((item) => (
            <div
              key={item.id}
              onClick={() => handleScroll(item.id)}
              className="relative cursor-pointer group"
            >
              <span className="text-[#5C523F] group-hover:text-[#000000] transition">
                {item.label}
              </span>

              <span className="absolute left-0 -bottom-1 w-0 h-[1.5px] bg-[#22C55E] transition-all duration-300 group-hover:w-full"></span>
            </div>
          ))}
        </div>

        {/* CTA */}


        
        <div className="hidden sm:flex">
       <div className="mt-0">
              <a
                href="https://www.linkedin.com/company/anna-foundations/"
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-[#0F172A] hover:bg-green-500 transition-all duration-300 text-white px-8 py-4 rounded-full flex items-center gap-3 tracking-wide w-fit shadow-lg"
              >
            Partner With Us

                <span className="group-hover:translate-x-1 transition-transform duration-300">
                  <ArrowRight size={18} />
                </span>
              </a>
            </div>
        </div>

        {/* Mobile button */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden text-3xl px-3 py-2"
        >
          ☰
        </button>
      </div>

      {/* MOBILE MENU */}
      <div
        className={`absolute top-24 left-1/2 -translate-x-1/2 w-[92%]
        bg-[#f5f1ea] border border-green-100
        text-[#000000] rounded-2xl shadow-lg px-6 md:hidden z-50
        flex flex-col gap-4 overflow-hidden
        transition-all duration-500
        ${
          open
            ? "opacity-100 translate-y-0 max-h-[500px] py-6"
            : "opacity-0 -translate-y-6 max-h-0 py-0"
        }`}
      >
        {navItems.map((item) => (
          <div
            key={item.id}
            onClick={() => handleScroll(item.id)}
            className="text-base px-5 py-3 rounded-lg hover:bg-[#22C55E] hover:text-white transition cursor-pointer text-center"
          >
            {item.label}
          </div>
        ))}

        <div className="mt-2 flex justify-center">
          <div className="mt-0">
              <a
                href="https://www.linkedin.com/company/anna-foundations/"
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-[#0F172A] hover:bg-green-500 transition-all duration-300 text-white px-8 py-4 rounded-full flex items-center gap-3 tracking-wide w-fit shadow-lg"
              >
            Partner With Us

                <span className="group-hover:translate-x-1 transition-transform duration-300">
                  <ArrowRight size={18} />
                </span>
              </a>
            </div>
        </div>
      </div>

    </div>
  );
}